import React, { FunctionComponent } from 'react';
import { IconProps } from '.';

const ArrowDown: FunctionComponent<IconProps> = ({ size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24' fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M12 5L12 19' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M15 16L12 19L9 16' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);

export default ArrowDown;
